import React from 'react';

const PaymentTestPage: React.FC = () => {
  const testStatuses = [
    { status: 'paid', id: 'tr_test_paid', label: 'Betaald (Success)' },
    { status: 'open', id: 'tr_test_open', label: 'Open (In Progress)' },
    { status: 'pending', id: 'tr_test_pending', label: 'Pending (Processing)' },
    { status: 'failed', id: 'tr_test_failed', label: 'Mislukt (Failed)' },
    { status: 'canceled', id: 'tr_test_canceled', label: 'Geannuleerd (Cancelled)' },
    { status: 'expired', id: 'tr_test_expired', label: 'Verlopen (Expired)' },
  ];

  const testPaymentStatus = (testId: string) => {
    window.location.href = `/donate/success?payment=${testId}`;
  };

  const getStatusClasses = (status: string) => {
    if (status === 'paid') {
      return 'border-neon-lime/25 bg-neon-lime/[.08] text-neon-lime hover:bg-neon-lime/[.14]';
    }
    if (status === 'open' || status === 'pending') {
      return 'border-warning-500/30 bg-warning-500/10 text-warning-400 hover:bg-warning-500/20';
    }
    return 'border-neon-pink/30 bg-neon-pink/[.08] text-neon-pink-soft hover:bg-neon-pink/[.14]';
  };

  return (
    <div className="min-h-screen py-12">
      <div className="max-w-4xl mx-auto px-4">
        <div className="sf-card p-8">
          <div className="sf-eyebrow mb-3">// test</div>
          <h1 className="text-2xl font-bold text-fg-bright tracking-tight mb-6">
            🧪 Payment Status Test Page
          </h1>

          <p className="text-fg-body mb-8">
            Test different Mollie payment statuses to see how the donation success page handles each case:
          </p>

          <div className="grid gap-4 md:grid-cols-2">
            {testStatuses.map((test) => (
              <button
                key={test.id}
                onClick={() => testPaymentStatus(test.id)}
                className={`p-4 text-left rounded-item border transition-colors ${getStatusClasses(test.status)}`}
              >
                <div className="font-semibold">{test.label}</div>
                <div className="text-sm font-mono opacity-80">ID: {test.id}</div>
              </button>
            ))}
          </div>

          <div className="mt-8 sf-notice-info">
            <h3 className="font-semibold text-neon-cyan mb-2">How to use:</h3>
            <ul className="text-sm text-fg-body space-y-1">
              <li>• Click any button above to test that payment status</li>
              <li>• The donation success page will load with mock payment data</li>
              <li>• Only "Betaald" should show the success message</li>
              <li>• All others should show appropriate error/status messages</li>
            </ul>
          </div>

          <div className="mt-6">
            <button
              onClick={() => window.location.href = '/donate'}
              className="sf-link"
            >
              ← Back to Donations
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentTestPage;
